import { FC } from 'react';
import { Grid } from '@material-ui/core';
import { Button, Text, Modal, OverlayPortal, StyledInput, Toast } from '@morressier/ts';
import CopyToClipboard from 'react-copy-to-clipboard';
import styled from 'styled-components';
import { toast } from 'react-toastify';
import { logEvent } from 'utils/eventTracking';

const StyledFormLabel = styled(Text).attrs({
  size: 'body1_new',
  fontWeight: 'semiBold',
})`
  margin-top: 1.5rem;
`;

const ModalRTMPCredentials: FC<{
  rtmpUrl: string;
  rtmpStreamKey: string;
  cancelAction: () => void;
}> = props => {
  const { rtmpUrl, rtmpStreamKey, cancelAction } = props;

  const modalBody = (
    <>
      <Text style={{ marginTop: '1rem' }}>
        These are the RTMP URL and Stream Key for this Session. Copy and paste them into your
        streaming software.
      </Text>

      <Grid container spacing={2}>
        <Grid item xs={12} md={8}>
          <StyledFormLabel>RTMP URL</StyledFormLabel>

          <StyledInput name="rtmpUrl" value={rtmpUrl} disabled />
        </Grid>
        <Grid item xs={12} md={4}>
          <br />
          <CopyToClipboard
            text={rtmpUrl}
            onCopy={() => {
              toast(() => <Toast title="RTMP URL successfully copied to clipboard" />);
              logEvent('HYBRID_CLICKED_COPY_LINK_URL');
            }}
          >
            <Button style={{ marginTop: '2rem' }}>Copy link</Button>
          </CopyToClipboard>
        </Grid>
      </Grid>

      <Grid container spacing={2}>
        <Grid item xs={12} md={8}>
          <StyledFormLabel>Stream Key</StyledFormLabel>

          <StyledInput name="streamKey" value={rtmpStreamKey} disabled />
          <Text
            color="grey"
            style={{
              marginBottom: 10,
              fontSize: '12px',
              lineHeight: '1rem',
              paddingLeft: '0.5rem',
            }}
          >
            We will provide with a different key for each session.
          </Text>
        </Grid>
        <Grid item xs={12} md={4}>
          <br />
          <CopyToClipboard
            text={rtmpStreamKey}
            onCopy={() => {
              toast(() => <Toast title="Stream Key successfully copied to clipboard" />);
              logEvent('HYBRID_CLICKED_COPY_LINK_KEY');
            }}
          >
            <Button style={{ marginTop: '2rem' }}>Copy link</Button>
          </CopyToClipboard>
        </Grid>
      </Grid>
    </>
  );
  return (
    <OverlayPortal>
      <Modal
        copies={{
          title: 'Connect RTMP',
        }}
        body={modalBody}
        close={cancelAction}
      />
    </OverlayPortal>
  );
};

export default ModalRTMPCredentials;
